import { BaseEventTarget } from './event.base';

/**
 *  用于组件之间的通信，比如B组件希望监听到A组件上面发生的eventName1事件，
 *  如果使用ViewEventTarget，则需要获得相应的对象才能进行事件绑定。
 */

type ICallback = (event: EventMessage) => void;

interface EventListener {
  listen(eventBus: EventBus);
}

class EventType {
  private _eventName: string;
  private _tags: Array<string> = [];

  set eventName(param: string) {
    this._eventName = param;
  }

  addTag(tag: string) {
    this._tags.push(tag);
  }

  accept(eventType: string) {

  }
}

/**
 * 事件对象
 * 包含：事件名称/事件源/事件参数
 */
export class EventMessage {
  eventName: string;
  tags: Array<string> = [];

  private _target: any;

  constructor() {

  }

  get target() {
    return this._target;
  }
}


/**
 * 每个页面对应一个EventBus对象，任何图表都能获得对EventBus对象的引用，
 * 从而监听自己感兴趣的事件源（指定对象的指定事件）
 */
// @dynamic
export class EventBus extends BaseEventTarget {
  private static _instanceMap: Map<any, EventBus> = new Map();

  private _methodCache = new Map();

  static getInstance(page: any) {
    if (!EventBus._instanceMap.has(page)) {
      EventBus._instanceMap.set(page, new EventBus());
    }
    return EventBus._instanceMap.get(page);
  }

  private constructor() {
    super();
    this.onDestroy(() => {
      if (this._methodCache) {
        this._methodCache.clear();
        this._methodCache = null;
      }
    });
  }

  registerMethod(methodName: string, method: Function) {
    if (methodName && method) {
      this._methodCache.set(methodName, method);
    }
    return this;
  }

  invoke(methodName: string, ...params) {
    if (this._methodCache.has(methodName)) {
      try {
        this._methodCache.get(methodName).apply(null, params);
      } catch (e) {
        console.error(e);
      }
    }
  }

  send(eventType, eventMessage: EventMessage) {

  }
}


